import { useSideModalClose } from "../UI/Modals/SideModal";
import { Close, Info } from "../../SVGS";
import EmptyState from "../UI/EmptyState/EmptyState";
import { TiketDetailsSkeletonStyles } from "./tiketDetailsSkeleton.styles";

// Error twin of TiketDetailsSkeleton: same card shell + close header, with an
// EmptyState instead of shimmer. No retry button — reopening the service
// (notification or list row) re-runs the fetch.
const TiketDetailsError = ({ closeModal }) => {
  const sideModalClose = useSideModalClose();
  const handleClose = sideModalClose || closeModal;

  return (
    <TiketDetailsSkeletonStyles>
      <div className="sk-card">
        <div className="sk-header">
          <span />
          <div
            className="sk-header__close"
            onClick={handleClose}
            role="button"
            aria-label="Close"
          >
            <Close />
          </div>
        </div>

        <div
          className="sk-body"
          style={{ alignItems: "center", justifyContent: "center" }}
        >
          <EmptyState
            icon={<Info />}
            title="Couldn't load service"
            subtitle="Something went wrong while loading the details. Close this and try again."
          />
        </div>
      </div>
    </TiketDetailsSkeletonStyles>
  );
};

export default TiketDetailsError;
